// Единственное место, где закреплён вид чисел в кабинете.
//
// Формат ОДИН для обоих языков (решение 02.09.2026, эпик i18n): разделитель
// групп — пробел, дробная часть — точка. По локали переводим даты и текст, но не
// суммы: партнёр сверяет доход в кабинете со своими отчётами и выгрузками, и
// «1,234.56» в EN против «1 234,56» в RU превращает каждый скриншот из поддержки
// в задачу на угадывание разделителя.
//
// До этого модуля вид числа зависел от места: `formatMoneyValue` отдавала
// «1,234.5» (en-US как есть), профит и баланс — «1 234.56» (en-US + замена
// запятых), утилита статистики — «1 234,56» (ru-RU), а тултип графика вообще
// брал локаль браузера. Разнобой был виден на одном экране.

const GROUP_SEPARATOR = ' ';

// Intl с фиксированной локалью + подмена разделителя: свой разбор числа на
// разряды здесь не нужен, а поведение округления остаётся стандартным.
function format(num: number, minimumFractionDigits: number, maximumFractionDigits: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  })
    .format(num)
    .replace(/,/g, GROUP_SEPARATOR);
}

// Yii отдаёт числа в JSON строками даже для numeric-полей БД, поэтому все
// форматтеры принимают и строку. Пробелы внутри строки срезаем: значение могло
// прийти уже отформатированным.
function toNumber(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const num = typeof value === 'number' ? value : Number.parseFloat(value.replace(/\s+/g, ''));
  return Number.isNaN(num) ? null : num;
}

// Счётчики: клики, подписки, хиты. Дробная часть — только если есть.
export function formatNumber(
  value: string | number | null | undefined,
  maximumFractionDigits = 2,
): string {
  const num = toNumber(value);
  if (num === null) return '0';
  return format(num, 0, maximumFractionDigits);
}

// Деньги в таблицах статистики и рефералов. Знаков после запятой столько,
// сколько прислал бэк (до трёх) — принудительные «.00» здесь не дорисовываем,
// чтобы вид колонок не менялся сверх смены разделителя.
export function formatMoneyValue(value: string | number | null | undefined): string {
  const num = toNumber(value);
  if (num === null) return '';
  return format(num, 0, 3);
}

// Балансы, профит и суммы выплат — всегда с двумя знаками: это денежные
// значения в интерфейсе, где «10 000» и «10 000.00» рядом выглядят как ошибка.
// Пустое/битое значение показываем нулём (согласовано ранее для баланса и
// профита: лучше 0.00, чем «нет данных» в денежном поле).
export function formatMoney(value: string | number | null | undefined): string {
  return format(toNumber(value) ?? 0, 2, 2);
}
